import { ArrowSmallDownIcon, ArrowSmallUpIcon, ArrowsUpDownIcon } from '../../../Icons';
import { jsx as _jsx } from "react/jsx-runtime";
export const resolveSortIcon = (theme, headerColor) =>
// eslint-disable-next-line react/display-name
_ref => {
  let {
    sortOrder
  } = _ref;
  const color = headerColor === 'dark' ? theme.tokens.ComponentTableSortIconColorSortedDark : theme.tokens.ComponentTableSortIconColorSorted;
  switch (sortOrder) {
    case 'ascend':
      {
        return /*#__PURE__*/_jsx(ArrowSmallUpIcon, {
          color: color,
          fontSize: '14px',
          id: 'table-sort-ascend-icon'
        });
      }
    case 'descend':
      {
        return /*#__PURE__*/_jsx(ArrowSmallDownIcon, {
          color: color,
          fontSize: '14px',
          id: 'table-sort-descend-icon'
        });
      }
    default:
      {
        return /*#__PURE__*/_jsx(ArrowsUpDownIcon, {
          color: theme.tokens.ComponentTableSortIconColorNoSort,
          fontSize: '14px',
          id: 'table-sort-no-sort-icon'
        });
      }
  }
};